<template>
<div class="body">

  <center></center>

</div>
</template>
<script type="text/javascript">
export default {
  name: 'home'
}
</script>
<style type="text/css">
  .test{
    height: 40px;
    background: #ccc;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue